// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PM_USERS_FORCE_LOGOUT_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    pmUserForceLogoutResult
} from 'Redux/actions';

// Helpers
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* sendPushNotification({ payload }) {
    try {

        let QUERY = `
            query sendPushNotification ($authId: String, $payload: AWSJSON) {
                result: sendPushNotification (authId: $authId, payload: $payload)
            }
        `

        const response = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(pmUserForceLogoutResult(response?.result))

    } catch (exc) {
        yield put(pmUserForceLogoutResult(false))
        ExceptionManager(
            exc,
            'Modules/pmUsers/.components/forceLogout/redux/saga',
            'sendPushNotification'
        );
    }
}

function* watchMethods() {
    yield takeEvery(PM_USERS_FORCE_LOGOUT_REQUEST, sendPushNotification);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}